export default "__VITE_ASSET__ICLNf1Jp__"